import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function OptionStormPage() {
  const [passA, setPassA] = useState('');
  const [passB, setPassB] = useState('');

  return (
    <TaskPage
      phase="gather"
      title="Option Storm"
      pageNumber={1}
      instruction="Make the haystack (fast). Two-pass write: Pass A (5 min) - list every idea/request/opportunity. Don't judge. Pass B (5 min) - add 3-5 wildcards (bold/'impossible' ideas that reveal assumptions)."
      whyItMatters="Diverge first, evaluate later. Generating a wide option set prevents premature judgment and reveals hidden assumptions."
      coachRail={{
        timing: "10 minutes",
        tips: "Do it silently first, then share. Collaboration comes after generation (better focus, lower cognitive switching).",
        debrief: "What patterns do you see? Which wildcards reveal hidden assumptions?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Pass A: Generate Options (5 minutes)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">List every idea/request/opportunity. Don't judge.</p>
          <TextArea
            label="Ideas, requests, opportunities"
            value={passA}
            onChange={(e) => setPassA(e.target.value)}
            placeholder="What keeps customers from success today?&#10;What's the smallest bet that could unlock outsized value?&#10;What would we do if we had to ship in 2 weeks?"
            rows={12}
          />
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Pass B: Add Wildcards (5 minutes)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Add 3-5 wildcards - bold/'impossible' ideas that reveal assumptions.</p>
          <TextArea
            label="Wildcard ideas"
            value={passB}
            onChange={(e) => setPassB(e.target.value)}
            placeholder="What 'impossible' ideas challenge our assumptions?&#10;What would we do if constraints didn't exist?&#10;What bold moves could transform this?"
            rows={8}
          />
        </div>

        <Callout type="tip" phase="gather">
          <div className="space-y-2 text-sm">
            <p><strong>Starter prompts:</strong></p>
            <ul className="list-disc list-inside space-y-1">
              <li>What keeps customers from success today?</li>
              <li>What's the smallest bet that could unlock outsized value?</li>
              <li>What would we do if we had to ship in 2 weeks?</li>
            </ul>
          </div>
        </Callout>
      </div>
    </TaskPage>
  );
}






